import { Button } from "@/ui-components/ui/button";
import { PageTitle, PageTitleContainer } from "@/ui-components/utils/menu-items/page-title";
import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import SalesRanksFetcher from "./fetcher";

const SalesRanks = () => {
  const [searchParams] = useSearchParams();
  const [searchQuery] = useState(searchParams.toString() || `page=1`);
  const [reload, setReload] = useState(false);

  return (
    <div>
      <PageTitleContainer>
        <div className="flex flex-row justify-between items-center">
          <PageTitle>Verkaufsränge</PageTitle>
          <div className="flex flex-row gap-2">
            <Link to={`/settings/sales-ranks/details`}>
              <Button variant="outline">Provisionsmodell Vorschau</Button>
            </Link>
            <Link to={`/settings/sales-ranks/create`}>
              <Button className="px-4 py-2 bg-blue-500 text-white rounded-md">+ Neuer Verkaufsrang</Button>
            </Link>
          </div>
        </div>
      </PageTitleContainer>
      <SalesRanksFetcher searchQuery={searchQuery} setReload={setReload} reload={reload} />
    </div>
  );
};

export default SalesRanks;
